import { HOMEBUILDER_STAGES, HOMEBUILDER_DIAGRAMS } from "@/data/homebuilderData";
import { DataPointList } from "./DataPointList";
import { VisualDiagram } from "./VisualDiagram";
import { StepLayout } from "./StepLayout";

interface Props { selectedKeys: Set<string>; onToggle: (key: string) => void; onRequestMissing: () => void; }

export function StructuralSectionStep({ selectedKeys, onToggle, onRequestMissing }: Props) {
  const stage = HOMEBUILDER_STAGES.find(s => s.id === "hb-structural-section")!;
  return (
    <div className="space-y-4 pb-20">
      <div className="space-y-1">
        <h2 className="text-2xl font-semibold">{stage.heading}</h2>
        <p className="text-muted-foreground">{stage.subHeading}</p>
      </div>
      <StepLayout
        height={560}
        dataCount={stage.dataPoints.length}
        visual={<VisualDiagram diagramLabel="Structural Section" dataPoints={stage.dataPoints} selectedKeys={selectedKeys} onToggle={onToggle} imageSrc={HOMEBUILDER_DIAGRAMS["hb-structural-section"]} />}
        list={<DataPointList dataPoints={stage.dataPoints} selectedKeys={selectedKeys} onToggle={onToggle} onRequestMissing={onRequestMissing} />}
      />
    </div>
  );
}
